import React from 'react';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ContactPage() {
  return <div className="pt-20 min-h-screen bg-gray-50" data-id="element-209" data-mp="nxg9fb46jqzz">
      <div className="bg-navy-900 text-white py-16" data-id="element-210" data-mp="spzo6belss6d">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-211" data-mp="sscbl434ruqt">
          <h1 className="text-4xl font-serif font-bold mb-4" data-id="element-212" data-mp="xoucfsvcb8xv">Contact Us</h1>
          <p className="text-xl text-gray-300" data-id="element-213" data-mp="104wi839wqej">We'd love to hear from you.</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8 pb-20" data-id="element-214" data-mp="51q8lr7zh0no">
        <div className="bg-white rounded-xl shadow-xl overflow-hidden grid grid-cols-1 lg:grid-cols-2" data-id="element-215" data-mp="9z8grfe6fbum">
          {/* Form */}
          <div className="p-8 md:p-12" data-id="element-216" data-mp="eznrs0azk79f">
            <h2 className="text-2xl font-bold text-navy-900 mb-6" data-id="element-217" data-mp="ewi5stxnllhx">
              Send us a message
            </h2>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-218" data-mp="1qdrmx9tb81g2">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-219" data-mp="1qfun2mo6fayi">
                <div data-id="element-220" data-mp="r055bkr8f8rp">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-221" data-mp="qyc6usqrvuus">
                    First Name
                  </label>
                  <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-navy-900 focus:border-transparent outline-none" placeholder="John" data-id="element-222" data-mp="hz79hpqy67k7" />
                </div>
                <div data-id="element-223" data-mp="3akk0v7lvzf9">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-224" data-mp="3a1aa1s40hcb">
                    Last Name
                  </label>
                  <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-navy-900 focus:border-transparent outline-none" placeholder="Doe" data-id="element-225" data-mp="3vcsip0tqz96i" />
                </div>
              </div>

              <div data-id="element-226" data-mp="3gjyrwj90z6mj">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-227" data-mp="36tgzidiwoazo">
                  Email Address
                </label>
                <input type="email" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-navy-900 focus:border-transparent outline-none" placeholder="john@example.com" data-id="element-228" data-mp="3btwe18exboj8" />
              </div>

              <div data-id="element-229" data-mp="3plt0avtwv47p">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-230" data-mp="3pl9rc4m8nq5t">
                  I am a...
                </label>
                <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-navy-900 focus:border-transparent outline-none" data-id="element-231" data-mp="3gs69zl8h2t5w">
                  <option data-id="element-232" data-mp="3ks86zh39iyeu">Job Seeker</option>
                  <option data-id="element-233" data-mp="ce808qeucna0">Employer</option>
                  <option data-id="element-234" data-mp="cd6glxjresgo">Partner</option>
                </select>
              </div>

              <div data-id="element-235" data-mp="h5q17egv6nuz">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-236" data-mp="h69daeju2i13">
                  Message
                </label>
                <textarea rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-navy-900 focus:border-transparent outline-none" placeholder="How can we help you?" data-id="element-237" data-mp="1ww0fd07fmut8"></textarea>
              </div>

              <Button variant="primary" fullWidth data-id="element-238" data-mp="1iw98djfc2eoq">
                Send Message
              </Button>
            </form>
          </div>

          {/* Info */}
          <div className="bg-navy-50 p-8 md:p-12 flex flex-col justify-between" data-id="element-239" data-mp="1dypjzqox8lj2">
            <div data-id="element-240" data-mp="1sv6ru7xwji0v">
              <h2 className="text-2xl font-bold text-navy-900 mb-6" data-id="element-241" data-mp="1svqaxrzagcgh">
                Contact Information
              </h2>
              <ul className="space-y-6" data-id="element-242" data-mp="1nxorh5xyab4h">
                <li className="flex items-start space-x-4" data-id="element-243" data-mp="348soee63clwf">
                  <MapPin className="h-6 w-6 text-gold-500 mt-1" data-id="element-244" data-mp="2zahhocb3erif" />
                  <div data-id="element-245" data-mp="2z9zfkz1r1j2l">
                    <span className="block font-bold text-navy-900" data-id="element-246" data-mp="2zctukb1zubom">
                      Office
                    </span>
                    <span className="text-gray-600" data-id="element-247" data-mp="1drykvgcnw4ae">
                      357 7th Ave, 2nd Floor
                      <br data-id="element-248" data-mp="1htk6bq39hqw7" />
                      New York, NY 10001, United States
                    </span>
                  </div>
                </li>
                <li className="flex items-start space-x-4" data-id="element-249" data-mp="1mugam4rizf25">
                  <Phone className="h-6 w-6 text-gold-500 mt-1" data-id="element-250" data-mp="1rt18vyn7vony" />
                  <div data-id="element-251" data-mp="1wrcic89lnx5n">
                    <span className="block font-bold text-navy-900" data-id="element-252" data-mp="1wqj990n64vkc">Phone</span>
                    <span className="text-gray-600" data-id="element-253" data-mp="21ib1rgpvxbd4">+1 (678) 807-3391</span>
                  </div>
                </li>
                <li className="flex items-start space-x-4" data-id="element-254" data-mp="25jwaqqzat5i1">
                  <Mail className="h-6 w-6 text-gold-500 mt-1" data-id="element-255" data-mp="25lh6gjxcmuhh" />
                  <div data-id="element-256" data-mp="2ak29er3zjs9m">
                    <span className="block font-bold text-navy-900" data-id="element-257" data-mp="2agmr7ff0m33z">Email</span>
                    <span className="text-gray-600" data-id="element-258" data-mp="2fic0apiog6pf">
                      contact@continuumtalentsolutions.com
                    </span>
                  </div>
                </li>
                <li className="flex items-start space-x-4" data-id="element-259" data-mp="2klmqjtxsmgnx">
                  <Clock className="h-6 w-6 text-gold-500 mt-1" data-id="element-260" data-mp="2fnbdlac7bq1h" />
                  <div data-id="element-261" data-mp="2fnut6kedq2cc">
                    <span className="block font-bold text-navy-900" data-id="element-262" data-mp="2blzlmy5uusq4">Hours</span>
                    <span className="text-gray-600" data-id="element-263" data-mp="2bo2m6c4mw493">
                      Mon-Fri: 9am - 6pm EST
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            <div className="mt-12 p-6 bg-white rounded-lg shadow-sm" data-id="element-264" data-mp="33fi43sv8x2sz">
              <h3 className="font-bold text-navy-900 mb-2" data-id="element-265" data-mp="2ykw2gheyuom3">
                Ready to talk now?
              </h3>
              <p className="text-gray-600 mb-4 text-sm" data-id="element-266" data-mp="2uklnwgd3ypvm">
                Schedule a free 15-minute consultation directly on our calendar.
              </p>
              <Button variant="outline" fullWidth data-id="element-267" data-mp="3mbrp704ketmh">
                Book Consultation
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}